package com.eladfinish.bible.contest.screens.randomVerse.model

import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import com.eladfinish.bible.contest.text.SpannableStringKMP

data class RandomizedVerse(
    val verseUiModel: VerseUiModel,
    /**
     * The raw verse text **without** gershaim/colon wrapping, used for processing
     * (prefs application, partitioning, pattern detection).  Corresponds to the
     * former VerseItem.strPasukContent.
     */
    val rawContent: String = "",
    /**
     * The parasha name the verse belongs to (Chumash only, empty otherwise).
     * Stored here because [VerseUiModel] does not carry parasha metadata.
     */
    val parasha: String = "",
    val halfSpannableStringKMP: SpannableStringKMP = SpannableStringKMP.empty,
    val fullSpannableStringKMP: SpannableStringKMP = SpannableStringKMP.empty,
)
